import config from "config/config";
import { getToken } from "js/formatting/getToken";

const addAlert = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(payload),
  };

  const response = await fetch(`${config.REG_API_BASE_URL}/alerts`, options);

  return response;
};

export default addAlert;
